const messageBarViewTemplate = ({messageText, primaryActionButtonText}) => `<div role="alert" class="message-bar-view-container">
   <div class="message-bar-view-content-container">
      <span class="message-bar-text-container">${messageText}</span>
      ${primaryActionButtonText ? `<button class="button button-cta message-bar-action-button">${primaryActionButtonText}</button>` : ''}
   </div>
</div>`;

export default messageBarViewTemplate;
